import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AddWarrantyServiceModel, DurationValueModel } from 'src/app/models/warrantyService/warrantyService.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { Router } from '@angular/router';
import { WarrantyServiceService } from 'src/app/services/warranty-service.service';
import { CurrencyPipe } from '@angular/common';



@Component({
  selector: 'app-warranty-service',
  templateUrl: './warranty-service.component.html',
  styleUrls: ['./warranty-service.component.css']
})
export class WarrantyServiceComponent implements OnInit {
  tinyMCEkey: string;
  warrantyServiceModel: AddWarrantyServiceModel = new AddWarrantyServiceModel();
  Loader: boolean = false;
  price1:string;
  price2:string;
  price3:string;
  price4:string;
  price5:string;
  installationPrice6:string;
  formattedPrice1;
  formattedPrice2;
  formattedPrice3;
  formattedPrice4;
  formattedPrice5;
  formattedPrice6;
  constructor(private currencyPipe : CurrencyPipe,private alertify: AlertifyService,private route:Router, private _warrantyServiceService: WarrantyServiceService) {
   }

  ngOnInit() {
    this.tinyMCEkey = environment.tinyMCEKey;
  }

  transformAmount(element) {
    this.formattedPrice1 = this.currencyPipe.transform(this.formattedPrice1, '$');
    element.target.value = this.formattedPrice1;
  }
  transformPrice2(element) {
    this.formattedPrice2 = this.currencyPipe.transform(this.formattedPrice2, '$');
    element.target.value = this.formattedPrice2;
  }
  transformPrice3(element) {
    this.formattedPrice3 = this.currencyPipe.transform(this.formattedPrice3, '$');
    element.target.value = this.formattedPrice3;
  }
  transformPrice4(element) {
    this.formattedPrice4 = this.currencyPipe.transform(this.formattedPrice4, '$');
    element.target.value = this.formattedPrice4;
  }
  transformPrice5(element) {
    this.formattedPrice5 = this.currencyPipe.transform(this.formattedPrice5, '$');
    element.target.value = this.formattedPrice5;
  }
  transformPrice6(element) {
    this.formattedPrice6 = this.currencyPipe.transform(this.formattedPrice6, '$');
    element.target.value = this.formattedPrice6;
  }
  getWarranyServiceData() {
    var featureEditorElement: HTMLIFrameElement = document.getElementById('Features_ifr') as HTMLIFrameElement
    this.warrantyServiceModel.WarrantyServiceTerm = featureEditorElement.contentWindow.document.getElementById('tinymce').innerHTML;
  }
  onSubmit() {
  var priceDuration1 = new DurationValueModel();
  priceDuration1.Duration = "1";
  priceDuration1.Price = this.price1;

  var priceDuration2 = new DurationValueModel();
  priceDuration2.Duration = "2";
  priceDuration2.Price = this.price2;

 var priceDuration3 = new DurationValueModel();
  priceDuration3.Duration = "3";
  priceDuration3.Price = this.price3;

  var priceDuration4 = new DurationValueModel();
  priceDuration4.Duration = "4";
  priceDuration4.Price = this.price4;

  var priceDuration5 = new DurationValueModel();
  priceDuration5.Duration = "5";
  priceDuration5.Price = this.price5;

  var priceDuration6 = new DurationValueModel();
  priceDuration6.Duration = "InstallationPrice"
  priceDuration6.Price = this.installationPrice6;

  var durations = new Array<DurationValueModel>();
  durations.push(priceDuration1);
  durations.push(priceDuration2);
  durations.push(priceDuration3);
  durations.push(priceDuration4);
  durations.push(priceDuration5);
  durations.push(priceDuration6);
  this.warrantyServiceModel.Duration = JSON.stringify(durations);
  if (this.warrantyServiceModel.Title == undefined || this.warrantyServiceModel.Title == null || this.warrantyServiceModel.Title == "") {
    this.alertify.error("Title Name is required");
    return;
  }
  if (this.warrantyServiceModel.WarrantyServiceTerm == undefined || this.warrantyServiceModel.WarrantyServiceTerm == null || this.warrantyServiceModel.WarrantyServiceTerm == "") {
    this.alertify.error("WarrantyServiceTerm  is required");
    return;
  }  
    this.Loader = true;   
    this._warrantyServiceService.WarrantyService(this.warrantyServiceModel)
    .subscribe(response => {
      this.Loader = false;
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.Loader = false;
        this.warrantyServiceModel = responseBody.responseData;
        this.alertify.success(responseBody.responseMessage);
        this.route.navigate(['warranty-service-listing']);

      } else {
        this.alertify.error(responseBody.responseMessage);
      }
      this.Loader = false;
    });
  }

  onCancel(){
    this.route.navigate(['warranty-service-listing']);
  }

}
